import { UPDATE_STATUS_LOADING_ACTION as UPDATE_STATUS_LOADING } from './../constants';

const initialState = {
  loading: false,
};

const status = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATUS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default status;
